import React from 'react';
import StoreButtonAndQrCodeView from '../../components/shared/StoreButtonAndQrCodeView/StoreButtonAndQrCodeView';

const ThankyouCardOffer = () => {
  return (
    <StoreButtonAndQrCodeView
      title={'OnboardingCardOffer.youAreAllSet'}
      description1={'OnboardingCardThankYou.ScanQRCodeText'}
    />
  );
};

export default ThankyouCardOffer;
